export default class LazyComponent {
  constructor(importer) {
    this.importer = importer;
  }

  async load() {
    const { default: Component } = await this.importer();
    return Component;
  }
}
